import React, { useState, useEffect } from "react";
import "./Profile.css";
import axios from "axios";
import IdentificationTable from "../Components/IdentificationTable";
import { useNavigate } from "react-router-dom";
function Profile(props) {
  const [user, setUser] = useState(localStorage.getItem("user") || "");
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      navigate("/loginuser");
    }
  }, [user, navigate]);
  const [formData, setFormData] = useState({
    email: props.user,
  });
  const [profileData, setProfileData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    designation: "",
    institution: "",
    city: "",
    country: "",
    type: "", // Add type field
  });
  const [error, setError] = useState("");
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/getProfile`,
          formData
        );
        setProfileData(response.data);
      } catch (error) {
        console.error("Error Getting Profile Info:", error);
        setError("Failed to load profile information.");
      }
    };
    fetchProfileData();
  }, [formData]);

  const handleEditToggle = () => {
    setIsEditing(!isEditing);
  };

  const handleChange = (e) => {
    setProfileData({
      ...profileData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSave = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/updateProfile`,
        profileData
      );
      setProfileData(response.data);
      setIsEditing(false);
    } catch (error) {
      console.error("Error Updating Profile Info:", error);
      setError("Failed to update profile information.");
    }
  };

  return (
    <div className="profile">
      <div className="profile-card">
        <div className="profile-header">Profile Information</div>
        {error && <div className="error-message">{error}</div>}
        <div className="profile-info">
          {Object.keys(profileData).map((key) => (
            <div className="profile-row" key={key}>
              <div className="profile-title">
                {key.charAt(0).toUpperCase() + key.slice(1)}:
              </div>
              {isEditing && key !== "type" ? (
                <input
                  type="text"
                  name={key}
                  value={profileData[key]}
                  onChange={handleChange}
                  className="profile-input"
                />
              ) : (
                <div className="profile-name">{profileData[key]}</div>
              )}
            </div>
          ))}
        </div>
        <div className="profile-actions">
          {isEditing ? (
            <button onClick={handleSave} className="profile-save-button">
              Save
            </button>
          ) : (
            <button onClick={handleEditToggle} className="profile-edit-button">
              Edit Profile Info
            </button>
          )}
        </div>
      </div>
      <IdentificationTable />
    </div>
  );
}

export default Profile;
